import { useIntl } from "react-intl";

import { parseDuration } from "@/utils/duration";

import {
  FlightInfo,
  type FlightInfoProps,
  FlightOverallTime,
} from "./FlightInfo";

type Props = Pick<FlightInfoProps, "origin" | "destination"> & {
  duration: string | null;
  stops: number;
  operatedBy?: string;
};

export const SingleFlightInfo = ({
  origin,
  destination,
  duration,
  stops,
  operatedBy,
}: Props) => {
  const intl = useIntl();

  return (
    <FlightInfo origin={origin} destination={destination}>
      <div className="flex flex-col">
        <FlightOverallTime
          overallTime={
            duration
              ? intl.formatMessage(
                  {
                    defaultMessage: "{hours}h {minutes}m",
                    description:
                      "Formatted flight or travel duration (e.g. '2h 30m')",
                  },
                  parseDuration(duration),
                )
              : null
          }
          stops={stops}
        />
        {operatedBy ? (
          <div className="text-center text-sm text-text-tertiary">{`${intl.formatMessage({ defaultMessage: "Flight operated by", description: "Prefix text before the operating carrier name (e.g. 'Flight operated by Fly Baghdad')" })} ${operatedBy}`}</div>
        ) : null}
      </div>
    </FlightInfo>
  );
};
